import React, {memo, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import DiscountsTable from '../DiscountsTable/DiscountsTable';
import {
  getDiscounts,
  getDiscountsLoading,
  getDiscountsPage,
  getEmailMarketingTrialDate,
  getHasNextPage,
  getLocationId,
  getOrderBySorting,
  getSortDirection
} from '../../../../../store/discounts/selectors';
import {
  CLEAR_DISCOUNTS,
  GET_DISCOUNTS,
  PUSH_MODALS_STACK,
  SET_DISCOUNT,
  SET_SORTING
} from '../../../../../store/discounts/action';
import {DISCOUNT_MODALS} from '../../../../../helpers/constants/discounts';
import {OrdersContainer} from '../../../orders/OrdersList/styles';
import ButtonScrollTop from '../../../../../components/buttons/ButtonScrollTop';

const DiscountsView = () => {
  const dispatch = useDispatch();
  const {
    push,
    location: {pathname}
  } = useHistory();
  const locationId = getLocationId();
  const discounts = getDiscounts();
  const hasNextPage = getHasNextPage();
  const discountsPage = getDiscountsPage();
  const loading = getDiscountsLoading();
  const status = pathname === '/discounts/active' ? 'active' : 'history';
  const orderBy = getOrderBySorting();
  const discountDirection = getSortDirection();
  const emailMarketingTrialDate = getEmailMarketingTrialDate();
  const {AllowedServiceFeatures, Timezone} = useSelector(
    (state) => state.user.activeLocation
  );

  useEffect(() => {
    dispatch(
      GET_DISCOUNTS({
        status,
        sort: {
          sortBy: orderBy,
          sort: discountDirection,
          sortDirection: discountDirection
        }
      })
    );
    return () => dispatch(CLEAR_DISCOUNTS());
  }, [locationId, status]);

  const onSort = (sort) => {
    dispatch(SET_SORTING(sort));
    // eslint-disable-next-line no-param-reassign
    sort.sortDirection = sort.sort;
    dispatch(CLEAR_DISCOUNTS());
    dispatch(GET_DISCOUNTS({status, sort}));
  };

  const popperActions = {
    editAction: (discount) => {
      dispatch(SET_DISCOUNT(discount));
      push('/discounts/wizard');
    },
    duplicateAction: (discount) => {
      const duplicate = {...discount};
      delete duplicate._id;
      delete duplicate.Status;
      duplicate.Name = `Duplicate ${duplicate.Name}`;
      dispatch(SET_DISCOUNT(duplicate));
      push('/discounts/wizard');
    },
    disableAction: (discount) =>
      dispatch(PUSH_MODALS_STACK({type: DISCOUNT_MODALS.DISABLE, discount})),
    deleteAction: (discount) =>
      dispatch(PUSH_MODALS_STACK({type: DISCOUNT_MODALS.DELETE, discount}))
  };

  const onScrollChange = () => {
    dispatch(
      GET_DISCOUNTS({
        status,
        page: discountsPage,
        sort: {
          sortBy: orderBy,
          sort: discountDirection,
          sortDirection: discountDirection
        }
      })
    );
  };

  return (
    <InfiniteScroll
      dataLength={discounts.length}
      next={onScrollChange}
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        overflow: 'inherit'
      }}
      hasMore={hasNextPage}
    >
      <OrdersContainer>
        <DiscountsTable
          discounts={discounts}
          status={status}
          loading={loading}
          onSort={onSort}
          orderBy={orderBy}
          discountDirection={discountDirection}
          popperActions={popperActions}
          allowedServiceFeatures={AllowedServiceFeatures}
          emailMarketingTrialDate={emailMarketingTrialDate}
          timezone={Timezone}
        />
      </OrdersContainer>
      <ButtonScrollTop />
    </InfiniteScroll>
  );
};

export default memo(DiscountsView);
